export default "__VITE_ASSET__kTqjDAVT__"